import Container from '@/components/Container';

import List from './list';
import { useMeditationStore } from './store/useMeditationStore';
import { useEffect } from 'react';
import Skeleton from './loading';
import Highlight from './highlight';
import Pagination from '@/components/Pagination';

export default function MeditationPage() {
  const { onInit, loading, meditationsMeta, onChangePage } = useMeditationStore();

  useEffect(() => {
    onInit();
  }, [onInit]);

  if (loading) {
    return <Skeleton />;
  }

  return (
    <>
      <Container className="mt-sh-30">
        <div className="col-span-12">
          <Highlight />
          <List />
          <Pagination
            pageSize={meditationsMeta?.pagination.pageCount || 1}
            currentPage={meditationsMeta?.pagination.page || 1}
            onChangePage={onChangePage}
          />
        </div>
      </Container>
    </>
  );
}
